var React = require('react');

function WalletInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"#000","strokeWidth":"2"},[React.createElement("path",{"d":"M20.7 8c1 0 1.8.6 1.8 1.4v10.7c0 .7-.8 1.4-1.8 1.4H3.3c-1 0-1.8-.7-1.8-1.4V9.4c0-.8.8-1.4 1.8-1.4h17.4z","key":0}),React.createElement("path",{"strokeLinecap":"square","d":"M4.4 7.4L14 1.7a2 2 0 0 1 2.8.8l2.7 4.7","key":1}),React.createElement("path",{"d":"M15.4 12.4h7.1v4.7h-7.1a2.3 2.3 0 1 1 0-4.7z","key":2})]));
}

WalletInline.defaultProps = {"width":"24","height":"24"};

module.exports = WalletInline;

WalletInline.default = WalletInline;
